(()=>{'use strict';
const enc=new TextEncoder();
function crc32(bytes){let c=0xffffffff;for(const b of bytes){c^=b;for(let i=0;i<8;i++)c=(c>>>1)^((c&1)?0xedb88320:0);}return(c^0xffffffff)>>>0;}
function archive(files){let offset=0;const chunks=[],directory=[];for(const [name,data] of files){const n=enc.encode(name),pad=(64-(offset+30+n.length+4)%64)%64,extra=new Uint8Array(4+pad),ev=new DataView(extra.buffer);ev.setUint16(0,0x1986,true);ev.setUint16(2,pad,true);const h=new Uint8Array(30),v=new DataView(h.buffer),crc=crc32(data);v.setUint32(0,0x04034b50,true);v.setUint16(4,20,true);v.setUint32(14,crc,true);v.setUint32(18,data.length,true);v.setUint32(22,data.length,true);v.setUint16(26,n.length,true);v.setUint16(28,extra.length,true);chunks.push(h,n,extra,data);const c=new Uint8Array(46),cv=new DataView(c.buffer);cv.setUint32(0,0x02014b50,true);cv.setUint16(4,20,true);cv.setUint16(6,20,true);cv.setUint32(16,crc,true);cv.setUint32(20,data.length,true);cv.setUint32(24,data.length,true);cv.setUint16(28,n.length,true);cv.setUint32(42,offset,true);directory.push(c,n);offset+=h.length+n.length+extra.length+data.length;}const length=directory.reduce((s,b)=>s+b.length,0),end=new Uint8Array(22),e=new DataView(end.buffer);e.setUint32(0,0x06054b50,true);e.setUint16(8,files.length,true);e.setUint16(10,files.length,true);e.setUint32(12,length,true);e.setUint32(16,offset,true);return new Blob([...chunks,...directory,end],{type:'model/vnd.usdz+zip'});}
function scene(w,h,texture,material){const x=w/2,y=h/2,depth=material==='Canvas'?.025:material==='Plexiglas'?.006:.001,rough=material==='Plexiglas'?.12:.85;return `#usda 1.0
(
 defaultPrim = "Root"
 metersPerUnit = 1
 upAxis = "Y"
)
def Xform "Root"
{
def Scope "Scenes" (kind = "sceneLibrary")
{
def Xform "Artwork" (
 prepend apiSchemas = ["Preliminary_AnchoringAPI"]
 sceneName = "Artwork on wall"
 customData = { bool preliminary_collidesWithEnvironment = 0 }
)
{
 uniform token preliminary:anchoring:type = "plane"
 uniform token preliminary:planeAnchoring:alignment = "vertical"
 def Xform "Mount"
 {
  double3 xformOp:translate = (0,0.02,0)
  float xformOp:rotateX = -90
  uniform token[] xformOpOrder = ["xformOp:translate","xformOp:rotateX"]
 def Mesh "Print" (prepend apiSchemas = ["MaterialBindingAPI"])
 {
  point3f[] points = [(${-x},${-y},${depth}),(${x},${-y},${depth}),(${x},${y},${depth}),(${-x},${y},${depth})]
  int[] faceVertexCounts = [3,3]
  int[] faceVertexIndices = [0,1,2,0,2,3]
  normal3f[] normals = [(0,0,1),(0,0,1),(0,0,1),(0,0,1)] (interpolation = "vertex")
  texCoord2f[] primvars:st = [(0,0),(1,0),(1,1),(0,1)] (interpolation = "vertex")
  uniform token subdivisionScheme = "none"
  uniform bool doubleSided = true
  rel material:binding = </Root/Scenes/Artwork/Surface>
 }
 def Mesh "Backing" (prepend apiSchemas = ["MaterialBindingAPI"])
 {
  point3f[] points = [(${-x},${-y},0),(${x},${-y},0),(${x},${y},0),(${-x},${y},0),(${-x},${-y},${depth}),(${x},${-y},${depth}),(${x},${y},${depth}),(${-x},${y},${depth})]
  int[] faceVertexCounts = [3,3,3,3,3,3,3,3,3,3]
  int[] faceVertexIndices = [0,2,1,0,3,2,0,1,5,0,5,4,1,2,6,1,6,5,2,3,7,2,7,6,3,0,4,3,4,7]
  uniform token subdivisionScheme = "none"
  rel material:binding = </Root/Scenes/Artwork/BackingMaterial>
 }
 }
 def Material "BackingMaterial"
 {
  token outputs:surface.connect = </Root/Scenes/Artwork/BackingMaterial/Shader.outputs:surface>
  def Shader "Shader"
  {
   uniform token info:id = "UsdPreviewSurface"
   color3f inputs:diffuseColor = (0.84,0.82,0.78)
   float inputs:roughness = 0.8
   token outputs:surface
  }
 }
 def Material "Surface"
 {
  token outputs:surface.connect = </Root/Scenes/Artwork/Surface/Shader.outputs:surface>
  def Shader "Shader"
  {
   uniform token info:id = "UsdPreviewSurface"
   color3f inputs:diffuseColor.connect = </Root/Scenes/Artwork/Surface/Texture.outputs:rgb>
   float inputs:roughness = ${rough}
   float inputs:metallic = 0
   token outputs:surface
  }
  def Shader "UV"
  {
   uniform token info:id = "UsdPrimvarReader_float2"
   token inputs:varname = "st"
   float2 outputs:result
  }
  def Shader "Texture"
  {
   uniform token info:id = "UsdUVTexture"
   asset inputs:file = @${texture}@
   token inputs:sourceColorSpace = "sRGB"
   token inputs:wrapS = "clamp"
   token inputs:wrapT = "clamp"
   float2 inputs:st.connect = </Root/Scenes/Artwork/Surface/UV.outputs:result>
   float3 outputs:rgb
  }
 }
}
}
}`;}
function measurements(value){const match=value.match(/(\d+(?:[.,]\d+)?)\s*[×xX]\s*(\d+(?:[.,]\d+)?)\s*cm/i);return match?[Number(match[1].replace(',','.')),Number(match[2].replace(',','.'))]:null;}
function panelLayout(panels,gap=5){const width=panels.reduce((sum,p)=>sum+p.dimensions[0],0)+gap*(panels.length-1);let edge=-width/2;return{dimensions:[width,Math.max(...panels.map(p=>p.dimensions[1]))],panels:panels.map(p=>{const x=edge+p.dimensions[0]/2;edge+=p.dimensions[0]+gap;return{...p,x};})};}
function seriesScene(panels,material){const first=scene(1,1,'',material),start=first.indexOf(' def Xform "Mount"'),end=first.lastIndexOf('\n}\n}\n}');return first.slice(0,start)+panels.map((p,i)=>{const item=scene(p.dimensions[0]/100,p.dimensions[1]/100,p.texture,material);return item.slice(item.indexOf(' def Xform "Mount"'),item.lastIndexOf('\n}\n}\n}')).replace(/\b(Mount|Print|BackingMaterial|Backing|Surface)\b/g,name=>name+i).replace('(0,0.02,0)',`(${p.x/100},0.02,0)`);}).join('\n')+first.slice(end);}
function configuration(card){const size=card.querySelector('[data-buy-size]'),material=card.querySelector('[data-buy-material]'),source=card.querySelector('[data-ar-source]');const dimensions=measurements(card.hasAttribute('data-ar-original')?card.dataset.arMeasurements||'':size?.selectedOptions[0]?.textContent||'');const img=card.querySelector('[data-material-preview] img');const c={dimensions,src:source?.dataset.src||img?.src,material:({paper:'Paper',canvas:'Canvas',plexi:'Plexiglas'}[material?.value]||material?.value||'Canvas'),title:card.dataset.arTitle||card.querySelector('h1,h2')?.textContent.trim()||'Artwork'};if(card.hasAttribute('data-ar-series')&&dimensions){const slides=JSON.parse(card.querySelector('.slides').textContent),images=slides.find(slide=>slide.images)?.images;if(images?.length){const layout=panelLayout(images.map(image=>({src:image.src,title:image.alt,dimensions})));c.panels=layout.panels;c.dimensions=layout.dimensions;c.src=images[0].src;}}return c;}
if(typeof module!=='undefined')module.exports={archive,scene,measurements,panelLayout,seriesScene,configuration};
const modal=document.querySelector('#arman-wall-ar');
if(!modal)return;
const texts=JSON.parse(document.querySelector('#wall-ar-text').textContent);
const status=modal.querySelector('[data-ar-status]'),link=modal.querySelector('[data-ar-launch]');
const prepared=new Map();
let blobURL,request=0;
const supported=()=>{try{return link.relList.supports('ar');}catch{return false;}};
const cacheKey=c=>JSON.stringify([c.panels||c.src,c.dimensions,c.material]);
function prepare(c){
 const key=cacheKey(c);
 if(prepared.has(key))return prepared.get(key);
 const result=(async()=>{
  const panels=c.panels||[{src:c.src,dimensions:c.dimensions,x:0}];
  const files=await Promise.all(panels.map(async(p,i)=>{
   const response=await fetch(p.src);if(!response.ok)throw Error('Texture');
   const bytes=new Uint8Array(await response.arrayBuffer());
   const extension=bytes[0]===0xff&&bytes[1]===0xd8?'jpg':bytes[0]===137&&bytes[1]===80?'png':null;
   if(!extension)throw Error('Image format');return['artwork-'+i+'.'+extension,bytes];
  }));
  const model=c.panels?seriesScene(panels.map((p,i)=>({...p,texture:files[i][0]})),c.material):scene(c.dimensions[0]/100,c.dimensions[1]/100,files[0][0],c.material);
  return archive([['artwork.usda',enc.encode(model)],...files]);
 })();
 prepared.set(key,result);
 result.catch(()=>{if(prepared.get(key)===result)prepared.delete(key);});
 while(prepared.size>6)prepared.delete(prepared.keys().next().value);
 return result;
}
async function open(card){
 const c=configuration(card);
 if(!c.dimensions||!c.src)return;
 const seq=++request;
 if(blobURL){URL.revokeObjectURL(blobURL);blobURL=null;}
 link.hidden=true;
 modal.querySelector('[data-ar-dimensions]').textContent=c.title+' · '+c.dimensions.join(' × ')+' cm';
 modal.showModal();
 if(!supported()){status.textContent=texts.unsupported;return;}
 status.textContent=texts.preparing;
 try{
  const model=await prepare(c);
  if(seq!==request||!modal.open)return;
  blobURL=URL.createObjectURL(model);
  link.href=blobURL+'#allowsContentScaling=0';
  link.setAttribute('download','arman-artwork.usdz');
  link.querySelector('img').src=c.src;
  link.hidden=false;
  status.textContent=texts.ready;
  link.click();
 }catch(error){if(seq===request)status.textContent=texts.failed;}
}
const warm=card=>{if(!supported()){const c=configuration(card);if(c.dimensions&&c.src)window.ArmanMobileRoom?.warm(c);return;}const c=configuration(card);if(c.dimensions&&c.src)prepare(c).catch(()=>{});};
const visibleCards=new WeakSet();
const observer='IntersectionObserver' in window?new IntersectionObserver(entries=>{for(const entry of entries){if(entry.isIntersecting){visibleCards.add(entry.target);warm(entry.target);}else visibleCards.delete(entry.target);}},{rootMargin:'200px'}):null;
function setup(root=document){
 root.querySelectorAll('[data-print-product],[data-ar-original],[data-ar-series]').forEach(card=>{
  if(card.querySelector('[data-wall-ar-open]'))return;
  const c=configuration(card);
  if(!c.dimensions||!c.src)return;
  const button=document.createElement('button');
  button.type='button';button.className='room-open';button.dataset.wallArOpen='';button.textContent=texts.open;
  let readyModel,readyKey,pending;
  const ready=()=>{
   const current=configuration(card),key=cacheKey(current);
   if(readyKey===key&&readyModel)return Promise.resolve(readyModel);
   if(pending?.key===key)return pending.promise;
   const promise=prepare(current).then(model=>{readyModel=model;readyKey=key;return model;});
   pending={key,promise};return promise;
  };
  const launch=model=>{
   const current=configuration(card);
   if(blobURL)URL.revokeObjectURL(blobURL);
   blobURL=URL.createObjectURL(model);
   link.href=blobURL+'#allowsContentScaling=0';
   link.setAttribute('download','arman-artwork.usdz');
   link.querySelector('img').src=current.src;
   link.click();
  };
  button.addEventListener('click',async()=>{
   if(!supported()){window.ArmanMobileRoom.open(configuration(card));return;}
   if(readyModel&&readyKey===cacheKey(configuration(card))){launch(readyModel);return;}
   button.disabled=true;button.textContent=texts.preparing;
   try{await ready();button.textContent=texts.open;button.disabled=false;button.focus();}
   catch{button.disabled=false;button.textContent=texts.open;open(card);}
  });
  if(supported())ready().catch(()=>{});
  card.querySelectorAll('[data-buy-size],[data-buy-material]').forEach(control=>control.addEventListener('change',()=>{if(supported())ready().catch(()=>{});}));
  button.addEventListener('pointerenter',()=>warm(card),{passive:true});
  card.querySelectorAll('[data-buy-size],[data-buy-material]').forEach(control=>control.addEventListener('change',()=>{if(visibleCards.has(card))warm(card);}));
  (card.querySelector('[data-buy-price],.product-price,.price,[data-series-options]')||card.querySelector('.product-info h1'))?.after(button);
  observer?.observe(card);
 });
}
for(const target of [document.querySelector('#MainContent'),document.querySelector('#quickview')]){
 if(target)new MutationObserver(()=>setup(target)).observe(target,{childList:true,subtree:true});
}
setup();
modal.querySelector('[data-ar-close]').addEventListener('click',()=>modal.close());
modal.addEventListener('close',()=>{request++;link.hidden=true;if(blobURL){URL.revokeObjectURL(blobURL);blobURL=null;}link.removeAttribute('href');});

})();

